import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';

import {
    CB,
    GOOGLE_PAY,
    APPLE_PAY,
    PAYPAL,
    ENTERPRISE_CARD
} from '../../../constants/paymentMethods';
import { PAYPAL_OPTIONS } from '../../../services/paypal/constants';

import PaypalButton from './PaypalButton';
import ApplePayButton from './ApplePayButton';
import NextStepButton from './NextStepButton';
import GooglePayButton from './GooglePayButton';
import CheckoutFlowPayButton from '../payment-step/payment-methods/checkout-flow/CheckoutFlowPayButton';

import './ButtonContainerStyle.scss';

const ButtonContainer = ({
    setStateOfTransaction,
    paymentType,
    cartTotalValue,
    userInfo,
    partnerId,
    kycNeeded,
    checkoutAllowed
}) => {
    const showNextStepButton =
        !paymentType ||
        [ENTERPRISE_CARD].includes(paymentType) ||
        (paymentType === CB && !checkoutAllowed);
    const showCheckoutPayButton = paymentType === CB && checkoutAllowed;
    const showApplePayButton = [APPLE_PAY].includes(paymentType);
    const showGooglePayButton = [GOOGLE_PAY].includes(paymentType);
    const showPaypalButton = [PAYPAL].includes(paymentType);

    return (
        <div id="payment-selection-button-wrapper">
            {showNextStepButton && (
                <NextStepButton
                    paymentType={paymentType}
                    setStateOfTransaction={setStateOfTransaction}
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                />
            )}

            {showCheckoutPayButton && <CheckoutFlowPayButton />}

            {showApplePayButton && (
                <ApplePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                />
            )}

            {showPaypalButton && (
                <PayPalScriptProvider options={PAYPAL_OPTIONS}>
                    <PaypalButton userInfo={userInfo} partnerId={partnerId} kycNeeded={kycNeeded} />
                </PayPalScriptProvider>
            )}

            {showGooglePayButton && (
                <GooglePayButton
                    userInfo={userInfo}
                    partnerId={partnerId}
                    cartTotalValue={cartTotalValue}
                />
            )}
        </div>
    );
};

ButtonContainer.propTypes = {
    setStateOfTransaction: PropTypes.func,
    paymentType: PropTypes.string,
    cartTotalValue: PropTypes.number,
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    kycNeeded: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        checkoutAllowed:
            state.ebon.ebons.ebonPaymentConfig && state.ebon.ebons.ebonPaymentConfig.checkoutAllowed
    };
};

export default connect(mapStateToProps)(ButtonContainer);



// WEBPACK FOOTER //
// ./src/components/funnel/buttons/ButtonContainer.js